import { createContext } from "react"
import { FlotiMapContext as FlotiMapContextType } from "./types"
import { initial_flotiMap } from "./reducer"

const FlotiMapContext = createContext<FlotiMapContextType>({ flotiMap: initial_flotiMap, dispatch: () => null})
export default FlotiMapContext
